import React from 'react';
import { makeStyles } from '@material-ui/core';
import lodashGet from 'lodash/get';
import { useFormatMessage } from 'react-intl-hooks';
import { addCommas } from '../../../utils';
import { COLOR_WHITE } from '../../colors';
import { skins } from '../skins';
import { HistoricalTrend } from '../HistoricalTrend';

const COPYRIGHT_YEAR = new Date().getFullYear();
const useStyles = makeStyles((theme)=> ({
    columnWraper: {
        display: 'flex',
        marginTop: '32px',
        height: '344px',
    },
    columnItem1: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        paddingLeft: '0px',
    },
    columnItem1Wrapper: {
        inlineSize: 'fit-content',
    },
    columnItem1Value: {
        fontSize: '62px',
        lineHeight: '82px',
        fontWeight: 700,
        textAlign: 'left',
    },
    columnItem1Label: {
        fontSize: '34px',
        lineHeight: '48px',
        fontWeight: 500,
        textAlign: 'center',
    },
    columnItem2: {
        flex: 1,
    },
    statsRow: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: '8px',
        borderBottom: `2px solid`,
        padding: '16px 0 16px 0',
        '&:first-child': {
            paddingTop: '0px',
        },
        '&:nth-last-child(1)': {
            borderBottom: 'none',
            paddingBottom: 0,
        },
    },
    statsRowItem: {
        display: 'flex',
        alignItems: 'center',
        textAlign: 'left',
    },
    statsRowItemValue: {
        paddingRight: '16px',
        fontSize: '60px',
        lineHeight: '84px',
        fontWeight: 700,
    },
    statsRowItemLabel: {
        fontSize: '24px',
        lineHeight: '32px',
        fontWeight: 500,
        maxWidth: '190px',
    },
    compliance: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '14px',
        lineHeight: '20px',
        marginTop: '24px',
    },
    disclaimer: {
        display: 'flex',
        alignItems: 'center',
        textAlign: 'end',
    },
    disclaimerText: {
        width: '295px',
        marginRight: '16px',
    },
    copyright: {
        width: '320px',
        textAlign: 'start',
    }
}));

export default function StatsStack(props) {
    const {
        medianDom: median_dom,
        medianDomTrend: median_dom_mm,
        medianPrice: median_price,
        medianPriceTrend: median_price_mm,
        activeListingsCount: active_listings_count,
        activeListingsCountTrend: active_listings_count_mm,
        newListingsCount: new_listings_count,
        fromMonth,
        toMonth,
        skin,
    } = props || {};
    const classes = useStyles(props);
    const t = useFormatMessage();
    const borderBottomColor = lodashGet(skins, `${skin}.LINE_COLOR`, COLOR_WHITE);

    return (
        <>
            <div className={classes.columnWraper}>
                <div 
                    className={classes.columnItem1}
                    style={{
                        paddingTop: lodashGet(skins, `${skin}.PRICE_PADDING_TOP`, 0)
                    }}
                >
                    <div className={classes.columnItem1Wrapper}>
                        <div className={classes.columnItem1Value}>
                            {median_price}
                        </div>
                        <div className={classes.columnItem1Label} dangerouslySetInnerHTML={{__html: t({ id: 'median_price' }, { separator: ' ' })}}></div>

                        <HistoricalTrend
                            value={median_price_mm}
                            fromMonth={fromMonth}
                            toMonth={toMonth}
                            size="large"
                            margin="8px auto"
                        />
                    </div>
                </div>

                <div className={classes.columnItem2}>
                    <div className={classes.statsRow} style={{borderBottomColor}}>
                        <div className={classes.statsRowItem}>
                            <div className={classes.statsRowItemValue}>
                                {`${active_listings_count > 0 ? addCommas(active_listings_count) : '-'}`}
                            </div>
                            <div className={classes.statsRowItemLabel} dangerouslySetInnerHTML={{__html: t({ id: 'active_listings' }, { separator: '<br/>' })}}></div>
                            
                            <HistoricalTrend
                                value={active_listings_count_mm}
                                fromMonth={fromMonth}
                                toMonth={toMonth}
                                size="small"
                            />
                        </div>

                    </div>

                    <div className={classes.statsRow} style={{borderBottomColor}}>
                        <div className={classes.statsRowItem}>
                            <div className={classes.statsRowItemValue}>
                                {`${median_dom > 0 ? addCommas(median_dom) : '-'}`}
                            </div>
                            <div className={classes.statsRowItemLabel} dangerouslySetInnerHTML={{__html: t({ id: 'median_dom' }, { separator: ' ' })}}></div>

                            <HistoricalTrend
                                value={median_dom_mm}
                                fromMonth={fromMonth}
                                toMonth={toMonth}
                                size="small"
                            />
                        </div>
                    </div>

                    <div className={classes.statsRow} style={{borderBottomColor}}>
                        <div className={classes.statsRowItem}>
                            <div className={classes.statsRowItemValue}>
                                {`${new_listings_count > 0 ? addCommas(new_listings_count) : '-'}`}
                            </div>
                            <div className={classes.statsRowItemLabel} dangerouslySetInnerHTML={{__html: t({ id: 'new_listings' }, { separator: '<br/> ' })}}></div>
                        </div>
                    </div>

                </div>
            </div>

            <div className={classes.compliance} style={{ color: lodashGet(skins, `${skin}.COMPLIANCE_COLOR`) }}>
                <div className={classes.copyright}>
                    <img src={lodashGet(skins, `${skin}.LR_LOGO_PATH`)} height={16} alt="LR Logo" />
                    <div>
                        &copy; ListReports {COPYRIGHT_YEAR}, {t({ id: 'copyright' })}
                    </div>
                </div>
                <div className={classes.disclaimer}>
                    <div className={classes.disclaimerText}>{t({ id: 'disclaimer' })}</div>
                    <img src={lodashGet(skins, `${skin}.EQUAL_HOUSING_LOGO_PATH`)} height={24} alt="Equal Housing logo" />
                </div>
            </div>
        </>
    );
}
